import React from 'react';
import ReactQuill from 'react-quill-new';
import { FaGear } from 'react-icons/fa6';
import 'react-quill-new/dist/quill.bubble.css';
import "quill-emoji/dist/quill-emoji.css";
import { FaList, FaTrash, FaCopy } from 'react-icons/fa6';
import LibraryModal from '../../../../../components/LibraryModal';
import { useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
// DnD Kit imports
import {
    DndContext,
    closestCenter,
    PointerSensor,
    useSensor,
    useSensors
} from '@dnd-kit/core';
import {
    arrayMove,
    SortableContext,
    useSortable,
    verticalListSortingStrategy
} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';

function SortableOption({ opt, idx, handleOptionChange, handleRemoveOption, 
    handleCopyOption, listeners, attributes, isDragging, setNodeRef, style,  handleImageClick, handleRemoveImage }) {
        const modules = {
            toolbar: [
                [{ 'header': [1, 2, 3, false] }],
                ['bold', 'italic', 'underline', 'strike'],
                [{ 'color': [] }, { 'background': [] }],
                [{ 'align': [] }],
                
                ['link'],
                ['clean'],
            ],
        };
    
        const formats = [
            'header', 'font', 'bold', 'italic', 'underline', 'strike',
            'color', 'background', 'align', 'list',
            'link',  
        ];
        
    return (
        <div
            ref={setNodeRef}
            style={{
                ...style,
                opacity: isDragging ? 0.5 : 1,
                background: isDragging ? "#f0f4ff" : undefined,
            }}
            className="flex flex-col gap-2 bg-white rounded p-3 shadow"
        >
            <div className="flex items-center gap-2">
                <div
                    className="w-5 h-5 rounded flex items-center justify-center"
                    style={{ overflow: 'hidden', minWidth: '20px', minHeight: '20px', cursor: 'grab' }}
                    {...attributes}
                    {...listeners}
                    title="Arraste para reordenar"
                >
                    <FaList className="text-gray-500 text-sm" />
                </div>
                <div className="flex flex-col items-center gap-2 " style={{zIndex:2}}>
                    
                  
                    <div
                        className="w-10 h-10 rounded cursor-pointer border-2 border-dashed border-gray-300 flex items-center justify-center relative"
                        style={{ overflow: 'hidden', minWidth: '60px', minHeight: '60px',zIndex:2 }}
                        onClick={() => handleImageClick(idx)}
                        title="Clique para escolher imagem"
                    >
                    
                        {opt.img ? (
                            opt.img.includes("http") ? (
                                <img src={opt.img} alt={opt.content} className="w-10 h-10 rounded object-cover" />
                            ) : (
                                <span className="text-gray-400 text-2xl">{opt.img}</span>
                            )
                        ) : (
                            <span className="text-gray-400 text-xs">Img</span>
                        )}
                    
                    </div>
                    {opt.img ? (
                        <div className="" onClick={() => handleRemoveImage(idx)} >
                            <FaTrash className="text-red-500 text-sm" />
                        </div>
                    ) : null}
                    
                </div>
                <div className="w-full" style={{zIndex:20}}>
                    <ReactQuill
                        theme="bubble"
                        value={opt.content}
                        onChange={e => handleOptionChange(idx, "content", e)}
                        modules={modules}
                        formats={formats}
                        style={{zIndex:20000000, height: '100px'}}
                    />
                </div>
                <div>
                    <button
                        type="button"
                        className="ml-2 text-red-500 hover:text-red-700"
                        onClick={() => handleRemoveOption(idx)}
                        title="Remover opção"
                    >
                        <FaTrash />
                    </button>
                    <button
                        type="button"
                        className="ml-2 text-gray-500 hover:text-gray-700"
                        onClick={() => handleCopyOption(idx)}
                        title="Copiar opção"
                    >
                        <FaCopy />
                    </button>
                </div>
            </div>
        </div>
    );
}

   
function DraggableOption({opt, idx, handleOptionChange, handleRemoveOption, handleCopyOption, modules, formats, handleImageClick, handleRemoveImage}) {
  
       const {
           attributes,
           listeners,
           setNodeRef,
           transform,
           transition,
           isDragging
       } = useSortable({ id: opt.id || idx });
   
       const style = {
           transform: CSS.Transform.toString(transform),
           transition,
           zIndex: isDragging ? 10 : undefined,
       };
   
       return (
           <SortableOption
               opt={opt}
               idx={idx}
               handleOptionChange={handleOptionChange}
               handleRemoveOption={handleRemoveOption}
               handleCopyOption={handleCopyOption}
               listeners={listeners}
               attributes={attributes}
               isDragging={isDragging}
               setNodeRef={setNodeRef}
               style={style}
               modules={modules}
               formats={formats}
               handleImageClick={handleImageClick}
               handleRemoveImage={handleRemoveImage}
           />
       );
   }
   

export default function ConfigQuiz({ block, setEditingBlock, updateBlock, nodes, node, updateNode }) {


    
    if(block.options === undefined){
        block.options = [
            {
                id: 'option-' + uuidv4(),
                img: block.img? block.img : "",
                content: "Escolha um",
            }
        ];
    } 
    const [open, setOpen] = useState(false);
    const [selectedOptionIndex, setSelectedOptionIndex] = useState(null);
 
 
    function handleImageClick(idx) { 
        setSelectedOptionIndex(idx);
        setOpen(true);
    }

    function handleRemoveImage(idx) {

        handleOptionChange(idx, "img", "");

        
    }
    function handleImageSelect(image) { 
        if (selectedOptionIndex !== null) {
            handleOptionChange(selectedOptionIndex, "img", image.url || image.src || image);
            setOpen(false);
            setSelectedOptionIndex(null);
        }
    }   
 
    function handleOptionChange(idx, field, value) {
         
       

        block.options[idx][field] = value; 
         updateBlock(block.id, { ...block, options: block.options });
         
      }

    function handleAddOption() {
        if(block.options === undefined){
            return;
         }
         const newOption = {
            id: 'option-' + uuidv4(),
            img: block.img? block.img : "",
            content: "Escolha um",
            destinationType: "step",
            target: null,
        };
        block.options.push(newOption);
        updateBlock(block.id, { ...block, options: block.options });
       
 
    }

    function handleRemoveOption(idx) {

        if(block.options === undefined){
            return;
         }
         
        const newOptions = block.options ? block.options.splice(idx, 1) : [];
        updateBlock(block.id, { ...block, options: newOptions });
       
    }

    function handleCopyOption(idx) {
       
      
        const optionToCopy = { ...block.options[idx], id: 'option-' + uuidv4() };
        block.options.push(optionToCopy);
        updateBlock(block.id, { ...block, options: block.options });
        
        
    }

    // DnD Kit setup
    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: {
                distance: 5,
            },
        })
    );

    function handleDragEnd(event) {
        const { active, over } = event;
        if (!over || active.id === over.id) return;
        const oldIndex = block.options.findIndex(opt => (opt.id || block.options.indexOf(opt)) === active.id);
        const newIndex = block.options.findIndex(opt => (opt.id || block.options.indexOf(opt)) === over.id);
        if (oldIndex === -1 || newIndex === -1) return;
        // Actually move the item in the array
        const newOptions = block.options ? arrayMove([...block.options], oldIndex, newIndex) : [];
        block.options = newOptions;
        updateBlock(block.id, 'options', newOptions);
    }

    function handleShowCheckboxChange(e) {
        if(e.target.checked){
            block.showCheckBox = true;
            updateBlock(block.id, 'showCheckBox', true);
        }else{
            block.showCheckBox = false;
            updateBlock(block.id, 'showCheckBox', false);
        }
      
       
    }

    function handleStyleChange(e) {
      
        block.style = e.target.value; 
        updateBlock(block.id, 'style', e.target.value);
       
    }

    function handleColumnsChange(e) {
        block.columns = e.target.value; 
        updateBlock(block.id, 'columns', e.target.value);
       
    }

    function handleOrderChange(e) {
        block.order = e.target.value; 
        updateBlock(block.id, 'order', e.target.value);
       
    }

    function handleMultipleSelectChange(e) {
        block.multiple = e.target.checked;
        updateBlock(block.id, 'multiple', e.target.checked);
       
    }

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, 3, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'align': [] }],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            ['link'],
            ['clean'],
        ],
    };

    const formats = [
        'header', 'font', 'bold', 'italic', 'underline', 'strike',
        'color', 'background', 'align', 'list',
        'link',  
    ];

    return (
        <div>
            <label className="block font-semibold mb-2">Opções:</label>
            <div className="p-2 bg-gray-100 rounded flex flex-col gap-4">
                <DndContext
                    sensors={sensors}
                    collisionDetection={closestCenter}
                    onDragEnd={handleDragEnd}
                >
                    <SortableContext
                        items={block.options.map((opt, idx) => opt.id || idx)}
                        strategy={verticalListSortingStrategy}
                    >
                        {block.options.length === 0 && (
                            <div className="text-gray-500 text-sm">Nenhuma opção adicionada ainda.</div>
                        )}
                        {block.options.map((opt, idx) => (
                            <DraggableOption
                                key={opt.id || idx}
                                opt={opt}
                                idx={idx}
                                handleOptionChange={handleOptionChange}
                                handleRemoveOption={handleRemoveOption}
                                handleCopyOption={handleCopyOption}
                                modules={modules}
                                formats={formats}
                                handleImageClick={handleImageClick}
                                handleRemoveImage={handleRemoveImage}
                            />
                        ))}
                    </SortableContext>
                </DndContext>
                <button
                    type="button"
                    className="mt-2 px-3 py-1 rounded bg-blue-500 text-white hover:bg-blue-600 w-fit self-start"
                    onClick={handleAddOption}
                >
                    + Adicionar opção
                </button>

                <div className="flex items-center gap-2">   
                    <label className="block font-semibold mb-2">Layout:</label>
                    <select className="w-full p-2 rounded border border-gray-300" value={block.columns} onChange={handleColumnsChange}>
                        <option value="list">Lista</option>
                        <option value="2-columns">2 Colunas</option>
                        <option value="3-columns">3 Colunas</option>
                        <option value="4-columns">4 Colunas</option>
                    </select>
                </div>

                <div className="flex items-center gap-2">   
                    <label className="block font-semibold mb-2">Estilo:</label>
                    <select className="w-full p-2 rounded border border-gray-300" value={block.style} onChange={handleStyleChange}>
                        
                        <option value="simple">Transparente</option>
                        <option value="light">Claro</option>
                        <option value="highlight">Destacado</option>
                    </select>
                </div>


                <div className="flex items-center gap-2">   
                    <label className="block font-semibold mb-2">Ordem:</label>
                    <select className="w-full p-2 rounded border border-gray-300" value={block.order} onChange={handleOrderChange}>
                        <option value="img-content">Imagem | Conteúdo</option>
                        <option value="content-img">Conteúdo | Imagem</option>
                    </select>
                </div>

                <div className="flex items-center gap-2">   
                    <label className="block font-semibold mb-2">Mostrar checkbox:</label>
                    <input className="w-5 h-5 accent-blue-500" type="checkbox" {...block.showCheckBox === true? "checked" : ""} onChange={handleShowCheckboxChange} />
                </div>

                <div className="flex items-center gap-2">   
                    <label className="block font-semibold mb-2">Múltiplas seleções:</label>
                    <input className="w-5 h-5 accent-blue-500" type="checkbox" {...block.multiple === true? "checked" : ""} onChange={handleMultipleSelectChange} />
                </div>

        
            </div>
            
            <LibraryModal
                open={open}
                onClose={() => {
                    setOpen(false);
                    setSelectedOptionIndex(null);
                }}
                onSelect={handleImageSelect}
            />
        </div>
    );
}